import { Input, Image, Text, View, MenuSale } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface State {
  data: any;
  statusName: any;    //当前账号身份 1管理员、2销售、3分拣员
}

export default class User extends Base {
  public config: Config = {
    navigationBarTitleText: '账户管理'
  };

  public state: State = {
    data: [],
    statusName: ['管理员','销售','分拣员'],
  };

  public didMount() {
    this.getUserInfo()
  }

  private link = url => {
    history.push(url);
  }

  private toPassword = () => {
    history.push("/saleTool/Password");
  }
  private toCounts = () => {
    history.push("/saleTool/Accounts");
  }

  private exit = async() => {
    const result = await confirm("确定退出登录？");
    if(!result){return;}
    user.logout();
    user.login();
  }

  private getUserInfo = async() => {
    const res = await this.apiClient.base.userListInfo()
    console.log(res);
    if(res && res.status == 10000){
      this.setState({
        data: res.body
      })
    }
    
  }

  public render() {
    const { data, statusName } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <MenuSale opt={[
            {
              title:"订单管理",
              ico:this.assets.saleTool.menuIco_aa,
              selectIco:this.assets.saleTool.menuIco_ab,
              url:'/saleTool/main'
            },
            {
              title:"账户管理",
              ico:this.assets.saleTool.menuIco_ba,
              selectIco:this.assets.saleTool.menuIco_bb,
              url:'/saleTool/user'
            }
          ]} 
          current={1}
        />
        
        <View className={styles.main}>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.tit}>姓名</Text>
              <Text className={styles.val}>{data.name}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.tit}>手机号</Text>
              <Text className={styles.val}>{data.phone}</Text>
            </View>
            <View className={styles.lis}>
              <Text className={styles.tit}>身份</Text>
              <Text className={styles.val}>{statusName[data.type-1]}</Text>
            </View>
          </View>
          <View className={styles.buttonBox}>
              <Text className={styles.passwordBtn} onClick={this.toPassword}>修改密码</Text>
              {data.type == 1 && (
                <Text className={styles.adminBtn} onClick={this.toCounts}>全部账号管理</Text>
              )}
              <View className={styles.exitBox}>
                <Text className={styles.exit} onClick={this.exit}>退出登录</Text>
              </View>
          </View>
        </View>
      </View>
    );
  }
}
